<template>
  <div id="app">
    <alert/>
    <router-view/>
    <not-found></not-found>
    <report-expired></report-expired>
    <session-timeout></session-timeout>
  </div>
</template>

<script>
import NotFound from './components/shared/NotFoundModal'
import ReportExpired from './components/shared/ReportExpiredModal'
import SessionTimeout from './components/shared/SessionTimeoutModal'
import Alert from '@/components/shared/Alert'

export default {
  components: {
    Alert,
    SessionTimeout,
    NotFound,
    ReportExpired,
  },
}
</script>
